<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">INVOICE GENERATION</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="invoiceGeneration">
            <div class="row mb-3 d-flex  align-items-center flex-wrap grid-margin justify-content-center" >
             
                <div class="col-xl-4 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                        <mat-label>Invoice Number</mat-label>
                        <div class="search-input-container">
                            <input formControlName="invoiceNumber" placeholder=" Enter Invoice Number"
                                id="search" matInput type="text" #searchInput >
                        </div>
                    </mat-form-field>
                    <button matSuffix aria-label="Search" class="badge bg-light-blue image-button"  (click)="generateInvoice()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>
                </div>

                <div class="col-xl-2 my-2" style="height: fit-content;align-self: end;">
                   
                        <!-- <button class="btn btn-secondary " (click)="searchreset()">
                            <i class="fa fa-refresh"> </i> Refresh
                        </button> -->
                        <app-button (refreshClicked)="searchreset()"></app-button>

                </div>
            </div>
            <ng-container *ngIf="IsHaveTable">
                <div class="row mb-3 mt-2">
                    <div class="col-xl-2">
                    </div>
                    <div class="col-xl-8">
                        <div class="payment-table">
                            <div class="table-responsive" style="overflow: hidden;">
                                <div class="row">
                                    <div class="col-12 ">
                                        <span class="title_header_bar">Result</span>
                                    </div>
                                </div>
                                <table class="table">
                                    
                                    <tbody>
                                        <tr>
                                            <th>Invoice Date</th>
                                            <td class="text-left">{{transdate}}</td>
                                        </tr>
                                        <tr>
                                            <th>Description</th>
                                            <td class="text-left">{{theirref}}</td>
                                        </tr>
                                        <tr>
                                            <th>Download</th>
                                            <td  class="d-flex justify-content-center mr-5 ">
                                                <div (click)="downLoadInvoiceBatch()" class="dowmload-button mr-5" title="Download Invoice">
                                                    <svg width="28" height="28" style="cursor: pointer;"
                                                        viewBox="0 0 24 24" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.19667 19.0217 4.00067 18.5507 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.0217 19.805 18.5507 20.0007 18 20H6Z"
                                                            fill="white" />
                                                    </svg>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-2">
                    </div>
                </div>
            </ng-container>
        </form>
    </div>
</div>